<template>
  <div>
    <!-- 智能诊断 -->
    <detailBase
      :id="id"
      :user="user"
      :result="result"
      :checkbox="checkbox"
      :user-info="userInfo"
      :disease-info="diseaseInfo"
      @changeRecommandProduct="_setRecommandProduct"
    />
    <!-- 解决方案 -->
    <solution
      :hand-list="handList"
      :hand-list-simple="handListSimple"
      :say-list="sayList"
      :suit-list="suitList"
      :cannot-list="cannotList"
      :food-list="foodList"
      :food-book="foodBook"
      :progress="progress"
      @solution="_setSolution"
      @changeRecommandProduct="_setRecommandProduct"
    ></solution>
    <!-- 门店推荐 -->
    <recomendDoctorRes
      :id="id"
      :commodity="commodity"
      :record_id="record_id"
      @changeRecommandProduct="_setRecommandProduct"
    ></recomendDoctorRes>
  </div>
</template>
<script>
import detailBase from './detailBase';
import solution from './solution';
import recomendDoctorRes from './recomendDoctorRes';

export default {
  components: {
    detailBase,
    solution,
    recomendDoctorRes
  },
  props: {
    record_id: [String, Number],
    id: [String, Number]
  },
  data() {
    return {
      userInfo: {},
      diseaseInfo: {},
      checkbox: {
        physique: true,
        solution: {
          solutionProduct: true,
          standardSolution: true,
          fastSolution: false,
          foodSolution: false,
          adjustSolution: false
        },
        recommand: {
          recommandProduct: false,
          productList: false
        }
      },
      user: {},
      result: {},
      product: [],
      doctors: [],
      recommendProductId: [],
      progress: {
        book: [],
        medicine: [],
        nutrition: [],
        physical: [],
        stick: [],
        fit_tuina: '',
        bubble: []
      },
      handList: {list: []},
      handListSimple: {list: []},
      sayList: {},
      foodList: {},
      foodBook: [],
      commodity: [],
      suitList: [],
      cannotList: []
    };
  },
  watch: {
    record_id: {
      handler(v) {
        if (v) {
          this.getRecord();
          //   this.getDoctors();
        }
      },
      immediate: true
    }
  },
  methods: {
    _setRecommandProduct(event) {
      const {val, prop} = event;
      const SOLUTION_TYPE = 'solution';
      const PHYSIQUE_TYPE = 'physique';
      const SOLUTION_PRODUCT = 'solutionProduct';

      if (prop) {
        if (prop === SOLUTION_TYPE) {
          this.checkbox.solution[prop] = val;
        } else if (prop === PHYSIQUE_TYPE) {
          this.checkbox[prop] = val;
        } else if (prop === SOLUTION_PRODUCT) {
          this.checkbox.solution[prop] = val;
        } else {
          this.checkbox.recommand[prop] = val;
        }
      }
    },

    _setSolution(event) {
      const {val, prop} = event;
      this.checkbox.solution[prop] = val;
    },
    getRecord() {
      this.$http
        .post(this.$url.getRecord, {
          u_id: this.id,
          record_id: this.record_id,
          is_medical: 2
        })
        .then(res => {
          this.user = res.user;
          this.result = res.result;
          this.progress = res.progress;
          this.handList = res.handList;
          this.handListSimple = res.handListSimple;
          this.sayList = res.sayList;
          this.foodList = res.foodList;
          this.foodBook = res.foodBook;
          this.commodity = res.commodity;
          this.suitList = res.suit;
          this.cannotList = res.cannot;
          this.diseaseInfo = res.result;
          this.userInfo = res;
        })
        .catch(this.$catch);
    }
  }
};
</script>
